import { render, staticRenderFns } from "./poker_resa.vue?vue&type=template&id=37e81be6&scoped=true&"
import script from "./poker_resa.vue?vue&type=script&lang=js&"
export * from "./poker_resa.vue?vue&type=script&lang=js&"
import style0 from "./poker_resa.vue?vue&type=style&index=0&lang=css&"
import style1 from "./poker_resa.vue?vue&type=style&index=1&id=37e81be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e81be6",
  null
  
)

export default component.exports